import { render, staticRenderFns } from "./TestimonialDeadlinePopUp.vue?vue&type=template&id=46b79580&scoped=true&"
import script from "./TestimonialDeadlinePopUp.vue?vue&type=script&lang=js&"
export * from "./TestimonialDeadlinePopUp.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialDeadlinePopUp.vue?vue&type=style&index=0&id=46b79580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b79580",
  null
  
)

export default component.exports